export const STAFF_PERMISSION_LIST = [
  {
    id: 1,
    title: "Permissions for appointment reports on dashboard",
    key: "appointmentreport",
    isEnabled: true,
  },
  {
    id: 2,
    title: "Enable my transaction dashboard access",
    key: "clinictransactionreport",
    infoContent: [
      {
        heading: "When the toggle button is ON:",
        content: [
          { id: 1, text: "Staff can view all users' transaction data." },
          {
            id: 2,
            text: "Staff can download comprehensive reports for all users.",
          },
        ],
      },
      {
        heading: "When the toggle button is OFF:",
        content: [
          { id: 1, text: "Staff can only view their own transaction data. " },
          {
            id: 2,
            text: "Staff can only download reports related to their own transactions.",
          },
        ],
      },
    ],
    isEnabled: true,
  },
];

export const STAFF_PERMISSION_SET = {
  APPOINTMENT_REPORT_ENABLED: [1, 1, 0, 0, 0],
  APPOINTMENT_REPORT_DISABLED: [0, 0, 0, 0, 0],
  CLINIC_TRANSACTION_REPORT_ENABLED: [1, 1, 0, 0, 0],
  CLINIC_TRANSACTION_REPORT_DISABLED: [0, 0, 0, 0, 0],
  USER_TRANSACTION_REPORT_ENABLED: [1, 1, 1, 1, 1],
};

export const DEFAULT_STAFF_ALERT_MESSAGE = {
  show: false,
  type: "",
  title: "",
  content: "",
};
